module.exports = __webpack_public_path__ + "img/9788937833335.77fc55d6.jpg";